<template>
  <vi-page>
    <vi-card>
      <template v-slot:title>
        <div class="row">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="icon-box">
                <vi-icon name="fas:shield-alt"></vi-icon>
              </div>
              <span class="ml-1 font-weight-bolder row">
                <span class="col-12">实名认证信息</span>
                <span class="col-12 font-size-sm text-muted"
                  >您的实名认证信息</span
                >
              </span>
            </div>
          </div>
        </div>
      </template>
      <div class="ml-15" v-if="applyData.approveStatus === 'Approve'">
        <div class="row align-items-center">
          <div class="col-lg-4 col-form-label text-right">
            <vi-icon
              name="fas:check-circle"
              color="success"
              :size="'30px'"
            ></vi-icon>
          </div>
          <div class="col-lg-4 text-success font-weight-boldest h3 mb-0">
            <span>实名认证已通过！</span>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 col-form-label text-right">认证类型：</div>
          <div class="col-lg-4">{{ applyData.typeText }}</div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 col-form-label text-right">企业名称：</div>
          <div class="col-lg-4">{{ applyData.businessNameText }}</div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 col-form-label text-right">证件号码：</div>
          <div class="col-lg-4">{{ applyData.codeNumberText }}</div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 col-form-label text-right">认证时间：</div>
          <div class="col-lg-4">{{ applyData.approveTimeText }}</div>
        </div>
      </div>
      <div class="ml-15" v-if="applyData.approveStatus === 'Reject'">
        <div class="row align-items-center ml-40">
          <div class="col-lg-4 col-form-label text-right">
            <vi-icon
              name="fas:times-circle"
              color="danger"
              :size="'30px'"
            ></vi-icon>
          </div>
          <div class="col-lg-4 text-danger font-weight-boldest h3 mb-0">
            <span>实名认证未能通过！</span>
          </div>
        </div>
        <div class="row align-items-center ml-40">
          <div class="col-lg-4 col-form-label text-right"></div>
          <div class="col-lg-4 font-size-h5">{{ applyData.rejectTimeText }}</div>
        </div>
        <div class="row align-items-center ml-40">
          <div class="col-lg-4 col-form-label text-right"></div>
          <div class="col-lg-4 font-size-h5">{{ applyData.rejectContentText }}</div>
        </div>
        <div class="apply_flex mt-15 mr-30">
          <button type="button" class="btn btn-outline-primary" @click="eCertification()">
            重新编辑
          </button>
        </div>
      </div>
      <div class="ml-15" v-if="applyData.approveStatus === 'Apply'">
        <div class="apply_flex">
          <div class="apply_flex" style="width:100%">
            <div class="row align-items-center font-size-h4">
              <vi-icon
                name="fas:paper-plane"
                color="primary"
                :size="'25px'"
              ></vi-icon>
              <span class="font-weight-bolder text-primary ml-3"
                >您已提交实名认证信息，请耐心等候1-3个工作日审核，谢谢。</span
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="applyData.approveStatus === 'Unknow'">
        <div class="apply_flex">
          <div class="row align-items-center font-size-h4">
            <vi-icon
              name="fas:exclamation-circle"
              color="#616161"
              :size="'25px'"
            ></vi-icon>
            <span class="font-weight-bolder ml-3"
              >您尚未提交实名认证申请，</span
            >
            <span class="text-primary pointer" @click="eCertification()"
              >申请认证</span
            >
          </div>
        </div>
      </div>
    </vi-card>
  </vi-page>
</template>

<script>
var moment = require("moment");
export default {
  name: "PagesDashboardShiyunAccountPrincipal",
  data() {
    return {
      applyData: {
        codeNumberText: "",
        typeText: "",
        businessNameText: "",
        approveTimeText: "",
        rejectTimeText: "",
        rejectContentText: "",
        approveStatus: "",
      },
    };
  },
  mounted() {
    this.oGetApplyCurrent();
  },
  methods: {
    oGetApplyCurrent() {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/principal/apply/current")
        .then((res) => {
          let data = res.data;
          this.applyData.approveStatus = data.approveStatus;
          if (data.content) {
            this.applyData.codeNumberText = this.ePlusXing(
              data.content.business.legal.number,
              3,
              3
            );
            this.applyData.businessNameText = data.content.business.name;
            this.applyData.typeText = this.eApplyType(data.type);
            this.applyData.approveTimeText = this.eGetTime(data.applyTime);
            this.applyData.rejectTimeText = this.eGetTime(data.rejectTime);
            this.applyData.rejectContentText = data.rejectContent;
          }
        })
        .catch(() => {});
    },
    ePlusXing(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = "";
      for (var i = 0; i < len; i++) {
        xing += "*";
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      );
    },
    eApplyType(type) {
      let result = "";
      switch (type) {
        case "Person":
          result = "个人";
          break;
        case "Business":
          result = "商业";
          break;

        default:
          result = "未知";
          break;
      }
      return result;
    },
    eGetTime(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD HH:mm:ss");
      return result;
    },
    eCertification() {
      this.$$.navigate.navigateCurrentClose();
      this.$$.navigate.to({
        label: `提交实名认证`,
        path: `/shiyun/account/principal/submit`
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-box {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  background: #1bc5bd;
  align-items: center;
  border-radius: 50%;
  i {
    color: #fff;
    font-size: 25px;
  }
}
.pointer {
  cursor: pointer;
}
.apply_flex {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
</style>